<template>
    <v-container>
        <div class="my-3">
            <h1 class="uiTitle header">
                Neue Berechnung
            </h1>
            <p class="mt-2 subtitle-1">Wollen Sie die bisherigen Daten löschen?</p>
        </div>
        <!-- BUTTON SECTION -->
        <div class="d-flex flex-column justify-center">
            <v-btn v-on:click="deleteAndStart" class="mb-3" outlined large color="indigo" aria-labelled-by="Ja, Daten löschen"><span class="black--text subtitle-1">Ja, Daten löschen</span></v-btn>
            <v-btn v-on:click="start" outlined large color="indigo" aria-labelled-by="Nein, Daten nicht löschen"><span class="black--text subtitle-1">Nein, Daten nicht löschen</span></v-btn>
        </div>
    </v-container>
</template>

<script>
    import {Component, Vue} from 'vue-property-decorator';
    import { EventBus } from '../eventbus';

    @Component
    export default class Berechnung extends Vue {

        data() {
            return {
                index: 0,
            };
        }

        mounted() {
            EventBus.$emit('scroll', this.$data.index)
        }

        deleteAndStart() {
            EventBus.$emit('reset')
            this.$router.push('wohnflaeche')
        }

        start() {
            this.$router.push('wohnflaeche')
        }
    }
</script>
